<template>
  <stat :title="$t('dashboard.averagetimespent.title')" :loading="loading">
    <average-time-chart
      v-if="totalResults !== 0"
      :dataKey="dataKey"
      :height="200"
      :params="params"
      style="width: 100%"
      lazy></average-time-chart>
    <small v-else>{{ $t('dashboard.averagetimespent.notActivated') }}</small>
  </stat>
</template>

<script>
  import { AverageTimeChart } from '@/components/charts'
  import stats from '@/mixins/stats'
  export default {
    components: {
      AverageTimeChart
    },
    mixins: [stats],
    props: {
      dataKey: {
        type: String,
        default: 'sessions'
      }
    }
  }
</script>

<style scoped>
  small { font-size: .5em; }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/AverageTimeSpent.vue